var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectBasedTic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 4V6.4375M8.84375 4V6.4375M12.5 4V6.4375",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 5.21875H11.6875C9.00639 5.21875 7.66583 5.21875 6.83292 6.05167C6 6.88458 6 8.22514 6 10.9062V14.5625C6 17.2436 6 18.5841 6.83292 19.4171C7.66583 20.25 9.00639 20.25 11.6875 20.25H13.3125C15.9936 20.25 17.3341 20.25 18.1671 19.4171C19 18.5841 19 17.2436 19 14.5625V10.9062C19 8.22514 19 6.88458 18.1671 6.05166C17.3341 5.21875 15.9936 5.21875 13.3125 5.21875Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14.5625H12.5M9.25 11.3125H15.75",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBasedTic);
export default __webpack_public_path__ + "static/media/project_based_tic.9224e7792b22f1d6a1ffb936a6ec74f1.svg";
export { ForwardRef as ReactComponent };